import { gql } from '@apollo/client';

export const GET_PAGE_OFFICES = gql`
query getPageOffices ($input: PageUrltagInput!) {
  getPageOffices(input: $input) { 
    count
    list {
      name
      legalName
      name
      address
      email
      urltag
      phone
    }
  }
}`;